
import React from 'react';
import { motion } from 'framer-motion';
import Lottie from 'lottie-react';
import offline from '../../animations/offline.json'

export default function OfflineYuboyPage({ lottieData = null, onRetry = null }) {
  const handleRetry = () => {
    if (onRetry) return onRetry();
    if (navigator.onLine) return window.location.reload();
    const el = document.getElementById('yuboy-card');
    if (el) {
      el.animate([
        { transform: 'translateY(0)' },
        { transform: 'translateY(-8px)' },
        { transform: 'translateY(0)' }
      ], { duration: 420, iterations: 1 });
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-gray-50 via-white to-gray-100 p-6">
      {/* subtle decorative background */}
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 0.12 }}
          transition={{ duration: 1 }}
          className="absolute -top-20 -left-40 w-[640px] h-[640px] bg-gradient-to-tr from-indigo-300 to-fuchsia-200 rounded-full blur-3xl"
        />
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 0.08 }}
          transition={{ duration: 1.2 }}
          className="absolute -bottom-32 -right-32 w-[540px] h-[540px] bg-gradient-to-tr from-amber-200 to-rose-100 rounded-full blur-2xl"
        />
      </div>

      <main
        id="yuboy-card"
        role="alert"
        aria-live="polite"
        className="relative z-10 w-full max-w-4xl rounded-2xl shadow-2xl bg-white/80 backdrop-blur-md border border-gray-200 p-8 flex flex-col md:flex-row items-center gap-8"
      >
        <section className="flex-1 flex items-center justify-center">
          <div className="w-64 h-64 flex items-center justify-center">
          <Lottie
        animationData={offline}
        loop={true}
        style={{ width: 300, height: 300 }}
      />
          </div>
        </section>

        {/* Right: text + actions */}
        <section className="flex-1">
          <h1 className="text-2xl md:text-3xl font-semibold text-gray-900">اتصال به اینترنت برقرار نیست</h1>
          <p className="mt-2 text-gray-600 leading-relaxed">
        اتصال شما به اینترنت قطع شده است. شبکه wifi خود را بررسی نمایید.
          </p>

          <div className="mt-6 flex flex-col sm:flex-row items-start sm:items-center gap-3">
            <motion.button
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.98 }}
              onClick={handleRetry}
              className="inline-flex items-center gap-3 px-5 py-3 rounded-lg bg-special text-white font-medium shadow-md focus:outline-none focus:ring-4 focus:ring-indigo-200"
            >
              دوباره تلاش کنید
            </motion.button>

         
            <a href="mailto:support@example.com" className="ml-auto text-sm text-gray-500 hover:underline">تماس با پشتیبانی</a>
          </div>

          <div className="mt-6 text-xs text-gray-500">
            پیشنهاد: اگر این صفحه مکرراً نمایش داده می‌شود، تنظیمات شبکه را بررسی نمایید یا با پشتیبانی تماس بگیرید.
          </div>
        </section>

      </main>

      {/* footer minimal */}
      <footer className="absolute bottom-6 text-sm text-gray-400">بارسرا</footer>
    </div>
  );
}
